import axios from 'axios'
import store from 'store'
import { mapNoticeItem, mapCourseItem } from 'utils/notices';
import { directDealApiHost } from 'config/env.conf';
//
const bizName = 'TICKET_INNER';
const apiRole = { apiRole: 'auto' };
const feClient = { feclient: 'lvyou_web' };
const bizType = { bizTypes: bizName };
const clinetWithApiRole = Object.assign({}, feClient, apiRole);
const clientWithApiRoleBizType = Object.assign({}, bizType, clinetWithApiRole);
// import qs from 'qs'

export const getAllCitys = () => axios.get(`/midas/api/v1/agent/prefecture/city/query`, {
    params: clinetWithApiRole
})

export const searchPoi = (params) => axios.get(`/midas/api/v1/agent/poi/es/query`, {
    params: Object.assign(params, apiRole)
})

export const searchTicket = (params) => axios.get('/midas/api/v1/agent/tickets/ipoi/query', {
    params: Object.assign(params, apiRole)
})

export const get = (id) => {
    const path = store.state.pageAccountType === 'mis' ? `/midas/mis/tickets/${id}` : `/midas/scs/account/op/tickets/${id}`
    return axios.get(path, {
        params: clinetWithApiRole
    })
}

export const create = (data) => {
    console.log(data);
    const path = store.state.pageAccountType === 'mis' ? `/midas/mis/tickets/` : `/midas/scs/account/op/tickets`

    return axios.post(path, data, {
        params: clinetWithApiRole
    })
}

export const update = (id, data) => {
    const path = store.state.pageAccountType === 'mis' ? `/midas/mis/tickets/${id}` : `/midas/scs/account/op/tickets/${id}`
    return axios.put(path, data, {
        params: clinetWithApiRole
    })
}

export const cancelAudit = (id) => {
    const path = store.state.pageAccountType === 'mis' ? `/midas/mis/tickets/cancel/audit` : `/midas/scs/account/op/tickets/cancel/audit`
    return axios.get(path, {
        params: Object.assign({ id: id }, clinetWithApiRole)
    })
}

export const audit = (id, params) => {
    if (store.state.pageAccountType === 'mis') {
        return axios.post(`/midas/mis/tickets/${id}/auditsubmit`, null, {
            params: Object.assign({
                opRole: 2
            }, clinetWithApiRole, params)
        })
    } else {
        return axios.post(`/midas/scs/account/op/tickets/${id}/auditsubmit`, null, {
            params: Object.assign({
                opRole: 3
            }, clinetWithApiRole, params)
        })
    }
}

export const checkRatio = (id) => {
    return axios.get(`/midas/mis/tickets/${id}/priceinfos`, {
        params: clinetWithApiRole
    })
}

export const getMsRatio = (poiIds, category, supplierId) => {
    const path = store.state.pageAccountType === 'mis' ? `/midas/mis/msratio/mtcategories/${category}` : `/midas/scs/account/op/msratio/mtcategories/${category}`
    return axios.get(path, {
        params: Object.assign({
            mtCategoryId: category,
            mdcPoiIds: poiIds,
            partnerSupplierId: supplierId
        }, clinetWithApiRole)
    })
}

export const getSubAccounts = (supplierId) => {
    const path = store.state.pageAccountType === 'mis' ? `/rimet/api/accounts/info` : `/rimet/account/allsubaccounts`
    return axios.get(path, {
        params: Object.assign({
            type: 1,
            businessType: 'TICKET',
            supplierId: supplierId
        }, clinetWithApiRole)
    })
}

export const getTicketParenthoodAdvice = (mdcPoiIds) => axios.get('/midas/api/v1/agent/get/poi/advice/ticket', {
    params: Object.assign({
        mdcPoiIds
    }, clinetWithApiRole)
})

/* old one
 export const getCertificateValidate = (mdcPoiIds) => {
 return axios.post('/midas/scs/account/v1/proxy/op/certificate/poi/validate', qs.stringify({
 mdcPoiIds,
 apiRole: 'auto',
 feclient: 'lvyou_web'
 }), {
 headers: {
 'Content-Type': 'application/x-www-form-urlencoded'
 }
 })
 }
 */

export const getCertificateValidate = (mdcPoiIds, supplierId) => {
    const path = store.state.pageAccountType === 'mis' ? `/midas/mis/poi/validate` : `/midas/scs/account/v1/proxy/op/certificate/poi/validate`
    return axios.post(path, null, {
        params: Object.assign({
            mdcPoiIds,
            partnerSupplierId: supplierId
        }, clinetWithApiRole)
    })
}

// 查询返佣协议接口
export const getCommissionStatement = (partnerId) => {
    return axios.get(`/midas/msc/v1/agent/get/commission/statement`, {
        params: Object.assign({
            partnerId: partnerId
        }, feClient)
    })
}

// BD
export const getContractsList4BD = (supplierId) => axios.get(`/virgo/supplier/contract/list/v2/${supplierId}`, {
    params: clientWithApiRoleBizType
})


export const getContractsList = (supplierId) => axios.get(`/virgo/fe/3f/supplier/contract/list/v2/${supplierId}`, {
    params: clientWithApiRoleBizType
})

// BD
export const getContractsDetail4BD = (contractId) => axios.get(`/virgo/supplier/contract/v2/simple/info/${contractId}`, {
    params: clientWithApiRoleBizType
})

export const getContractsDetail = (contractId) => axios.get(`/virgo/fe/3f/supplier/contract/v2/simple/info/${contractId}`, {
    params: clientWithApiRoleBizType
})

export const tehuiCheck = (dealId) => {
    return axios.get(`/midas/mis/specialticket/specialInfo`, {
        params: Object.assign({
            dealId: dealId,
        }, clinetWithApiRole)
    })
}

export const tehuiApply = (data) => {
    return axios.post(`/midas/mis/specialticket/apply`, data, {
        params: clinetWithApiRole
    })
}

export const getCrowdByPoi = (poiIds) => {
    return axios.get(`/midas/api/v1/agent/mtp/poi/fitpeople`, {
        params: Object.assign({
            mdcPoiIds: poiIds.join(',')
        }, clinetWithApiRole)
    })
}

export const getTicketType = (ticketId) => axios.get('/midas/api/v1/agent/mtp/ticketcategoryid/fitpeople', {
    params: Object.assign({
        ticketCategoryId: `${ticketId}`
    }, feClient)
})

export const getprotocol = (supplierId, contractNum) => axios.get(`/midas/mis/supplier/${supplierId}/protocol?feclient=lvyou_web&contractNum=${encodeURIComponent(contractNum)}`)

// 图片上传
export const uploadImage = `/midas/common/v1/upload`

/***
 * 查询产品价格基础数据
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @returns {*}
 */
export const getPriceBase = (partnerId, partnerDealId) => {
    return axios.get(`${directDealApiHost}/product/mtp/inner/price/levelPriceBase`, {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId
        }, feClient)
    })
}

/***
 * 保存价格基础信息
 * @param partnerId
 * @param partnerDealId
 * @param data
 * @returns {*}
 */
export const savePriceBase = (partnerId, partnerDealId, data) => {
    return axios.put(`${directDealApiHost}/product/mtp/inner/price/levelPriceBase`, {
        partnerId: partnerId,
        partnerDealId: partnerDealId,
        data: data
    }, {
        params: clinetWithApiRole
    })
}
/***
 * 保存层级映射表
 * @param partnerId
 * @param partnerDealId
 * @param data
 * @returns {*}
 */
export const saveMappingExt = (partnerId, partnerDealId, levelNo = 1, data) => {
    return axios.put(`${directDealApiHost}/product/mtp/inner/price/levelMappingExt`, {
        partnerId: partnerId,
        partnerDealId: partnerDealId,
        levelNo: levelNo,
        data: data
    }, {
        params: clinetWithApiRole
    })
}
/***
 * 查询层级映射信息
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @param levelNo 场次:1 席位:2 场馆:3
 * @returns {*}
 */
export const getMappingExt = (partnerId, partnerDealId, levelNo = 1) => {
    return axios.get(`${directDealApiHost}/product/mtp/inner/price/levelMappingExt`, {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId,
            levelNo: levelNo
        }, feClient)
    })
}
/***
 * 查询全局层级映射表顺序
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @param levelNo 场次:1 席位:2 场馆:3
 * @returns {*}
 */
export const getMappingSort = (partnerId, partnerDealId, levelNo = 1) => {
    return axios.get(`${directDealApiHost}/product/mtp/inner/price/levelMapping`, {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId,
            levelNo: levelNo
        }, feClient)
    });
}
/***
 * 保存全局层级映射表顺序
 * @param partnerId
 * @param partnerDealId
 * @param data
 * @returns {*}
 */
export const saveMappingSort = (partnerId, partnerDealId, levelNo = 1, data) => {
    return axios.put(`${directDealApiHost}/product/mtp/inner/price/levelMapping`, {
        partnerId: partnerId,
        partnerDealId: partnerDealId,
        levelNo: levelNo,
        data: data
    }, {
        params: clinetWithApiRole
    })
}
/***
 * 查询全部层级映射信息
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @param levelNo 场次:1 席位:2 场馆:3
 * @returns {*}
 */
export const getAllMappingExtType = (partnerId, partnerDealId) => {
    return axios.get(`${directDealApiHost}/product/mtp/inner/price/levelMappingExt/allType`, {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId
        }, feClient)
    })
}

/***
 * BA鉴权 获取POI白名单列表（鲁班）
 * @returns {*}
 */
export const getWhitelist = () => {
    return axios.get(`/midas/mis/lion/poi/whitelist`, {
        params: feClient
    })
}

// 直连判断有误价格日历
export const queryCalendar = (supplierId) => axios.get(`/rhone/mtp/partner/tech/fe/get?partnerId=${supplierId}`)

// 拉取价格日历
export const asyncTicket = (supplierId, partnerDealId) => {
    const path = store.state.pageAccountType === 'mis' ? `/midas/mis/sync/api/daypricestock` : `/midas/scs/account/op/sync/api/daypricestock`
    return axios.get(path, {
        params: Object.assign({
            partnerId: supplierId,
            partnerDealId: partnerDealId
        }, feClient)
    })
}

export const getSignUpActivities = (count, sortType) => {
    return axios.get('/rimet/activity/v2/slot/list', {
        params: {
            count: count,
            page: 1,
            slotStatus: 0,
            sortType: sortType || 2
        }
    }).then(response => {
        let activities = response && response.data || [];
        if (activities && activities.length) {
            let now = new Date().valueOf();
            activities = activities.filter((activity) => {
                let applyStartTime = activity.applyStartTime;
                let applyEndTime = activity.applyEndTime;
                if (applyStartTime && applyEndTime) {
                    let start = new Date(applyStartTime).valueOf();
                    let end = new Date(applyEndTime).valueOf();
                    return now > start && now < end;
                }
                return false;
            });
        }
        return activities;
    });
};

export const getAnnounces = function (bizLineId) {
    return axios.get('/trip-notify/acc/announces/special', {
        params: {
            bizLineId: bizLineId,
            servicePlatform: 1
        }
    }).then((respone) => {
        let data = respone && respone.data;
        if (data.noticeAnnPublishList) {
            data.notices = data.noticeAnnPublishList.map((noticeItem) => {
                return mapNoticeItem(noticeItem);
            });
        }
        if (data.ruleAnnPublishList) {
            data.rules = data.ruleAnnPublishList.map((ruleItem) => {
                return mapNoticeItem(ruleItem);
            });
        }
        if (data.meidaAnnPublishList) {
            data.courses = data.meidaAnnPublishList.map((courseItem) => {
                return mapCourseItem(courseItem);
            })
        }
        if (data.stripeDecorateList) {
            data.bannerTexts = data.stripeDecorateList.map((stripItem) => {
                return {
                    id: stripItem.announceId,
                    text: stripItem.decorateContent
                };
            });
        }
        if (data.bannerDecorateList) {
            data.bannerImages = data.bannerDecorateList.map((imgItem) => {
                return {
                    id: imgItem.announceId,
                    src: imgItem.decorateContent
                }
            });
        }
        if (data.rightDialogDecorateList) {
            data.topNotices = data.rightDialogDecorateList.map((dialogItem) => {
                return {
                    title: dialogItem.decorateTitle,
                    content: dialogItem.decorateContent,
                    id: dialogItem.announceId
                }
            });
        }
        return data;
    });
}

export const getBdsInfo = function (supplierId) {
    return axios.get(`/virgo/fe/3f/bsnsfe/base/bdInfo/${supplierId}?feclient=lvyou_web`).then(response => response.data);
}

export const codeDetail = function (code) {
    return axios.get(`/meilv/trade/ticket/merchant/v2/voucher/show/${code}`, {
        params: feClient
    })
}

export const getMainOrderInfo = function (params) {
    return axios.get(`/dpack-trade/dpack/merchant/query/orderRelation`, { params });
}

export const verify = function (data) {
    return axios.post(`/meilv/scs/account/v1/voucher/verify`, data);
}



// WEBPACK FOOTER //
// ./src/api/ticket.js